import React, { FC } from "react";
import { FunctionField, ShowProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { GridinRowsWithSpace } from "utils/style";
import CustomBooleanField from "components/CustomBooleanField";
import ShowCcaDocumentButton from "./components/ShowCcaDocumentButton";
import { ccaDropOffLocationType, ccaRateChartType } from "./const";
import CustomLabeled from "../../components/layout/CustomLabeled";
import CustomTooltip from "../../components/CustomTooltip";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles({
  captionTooltip: {
    marginTop: "5px",
    marginBottom: "5px",
  },
  labelWrapper: {
    display: "inline",
  },
  infoIcon: {
    verticalAlign: "middle",
    marginLeft: "5px",
  },
});

const CcaDetail: FC<ShowProps> = () => {
  const classes = useStyles();

  const ccaRateChartDropOffTypeFormatter = (
    id: string,
    source: any,
  ): string => {
    const item = source.find((type: any) => type.id === id);
    return item ? item.name : "-";
  };

  return (
    <>
      <FunctionField
        render={(record: any) =>
          record.isCcaSettingEnable ? (
            <SanitizedGrid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  CCA Detail
                </Typography>
              </Grid>

              <Grid item xs={3}>
                <CustomLabeled name="Type for Cca Drop-off Location">
                  <FunctionField
                    render={(record: any) =>
                      ccaRateChartDropOffTypeFormatter(
                        record.ccaDropOffType,
                        ccaDropOffLocationType,
                      )
                    }
                  />
                </CustomLabeled>
              </Grid>

              <Grid item xs={3}>
                <CustomLabeled name="Type for Cca Rate Chart Calculation">
                  <FunctionField
                    render={(record: any) =>
                      ccaRateChartDropOffTypeFormatter(
                        record.ccaRateChartType,
                        ccaRateChartType,
                      )
                    }
                  />
                </CustomLabeled>
              </Grid>
              <Grid item xs={6}></Grid>

              <Grid item xs={3}>
                <CustomLabeled name="Allow Parent to Select Wave">
                  <CustomBooleanField
                    source="isAllowParentSelectWave"
                    textForTrueValue="Yes"
                    textForFalseValue="No"
                  />
                </CustomLabeled>
              </Grid>
              <Grid item xs={3}>
                <FunctionField
                  addLabel={false}
                  render={(record: any) => (
                    <CustomLabeled name="Use Different Cca Split Payment">
                      <div className={classes.labelWrapper}>
                        <CustomBooleanField
                          source="useDifferentCcaSplitPayment"
                          textForTrueValue="Yes"
                          textForFalseValue="No"
                        />
                        <CustomTooltip
                          title={
                            record.useDifferentCcaSplitPayment ? (
                              <Typography variant="caption">
                                The CCA Split Payment setting appears in the
                                Payment Setting Menu, allowing admin to
                                configure different CCA split payment percentage
                                for each student.
                              </Typography>
                            ) : (
                              <Typography variant="caption">
                                The CCA split payment percentages are same as
                                Regular split payment percentages.
                              </Typography>
                            )
                          }
                          aria-label="Use Different Cca Split Payment"
                          classes={{
                            tooltip: classes.captionTooltip,
                          }}
                          placement="bottom-start"
                          component="span"
                        >
                          <InfoIcon
                            fontSize="small"
                            color="secondary"
                            className={classes.infoIcon}
                          />
                        </CustomTooltip>
                      </div>
                    </CustomLabeled>
                  )}
                />
              </Grid>
              <Grid item xs={6}></Grid>

              <Grid item xs={3}>
                <CustomLabeled name="Allow Multiple Cca Academic Year In One Regular Academic Year">
                  <CustomBooleanField
                    source="isAllowManyCcaAyInOneRegularAy"
                    textForTrueValue="Yes"
                    textForFalseValue="No"
                  />
                </CustomLabeled>
              </Grid>
              <Grid item xs={9}>
                <CustomLabeled name="Allow Parent Update Cca Schedule When Confirm Renewal">
                  <CustomBooleanField
                    source="isAllowParentUpdateScheduleWhenRenewal"
                    textForTrueValue="Yes"
                    textForFalseValue="No"
                  />
                </CustomLabeled>
              </Grid>

              <Grid item xs={6}>
                <CustomLabeled name="Cca Document">
                  <>
                    <ShowCcaDocumentButton
                      schoolId={record.id}
                      documentType="readme"
                      label="Show CCA Readme"
                    />
                    {record.ccaEventPdfUrl && (
                      <ShowCcaDocumentButton
                        schoolId={record.id}
                        documentType="event"
                        label="Show CCA Event"
                      />
                    )}
                  </>
                </CustomLabeled>
              </Grid>
              <Grid item xs={6}></Grid>
            </SanitizedGrid>
          ) : (
            <>
              <Grid item xs={12} style={GridinRowsWithSpace}>
                <Typography variant="h6" gutterBottom>
                  CCA Setting is Disabled
                </Typography>
              </Grid>
            </>
          )
        }
      />
    </>
  );
};

export default CcaDetail;
